import * as React from "react"
import { Template } from "components"
import ToastProvider from "components/toast/ToastProvider"
import CartProvider from "components/cart/CartProvider"
import AuthProdvider from "components/auth-provider"
import { ErrorBoundary } from "components/special-pages"

const App: React.FC = ({ children }) => {
	return (
		<ToastProvider>
			<CartProvider>
				<AuthProdvider>
					<Template>
						<ErrorBoundary>{children}</ErrorBoundary>
					</Template>
				</AuthProdvider>
			</CartProvider>
		</ToastProvider>
	)
}

export default App
